<template>
  <a-layout class="role-manage">
    <a-layout-sider width="280" style="background: #fff;padding:16px 0 16px 16px">
      <tree></tree>
    </a-layout-sider>
    <a-layout-content style="background: #fff;padding: 16px">
      <div class="content">
        <left-table />
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import leftTable from './table.vue'
import tree from './tree.vue'
export default {
  components: {
    leftTable,
    tree
  }
}
</script>

<style>

</style>
